import React from 'react'
import { DashboardCard } from './OutstandingBalance'
import CardIconHeader from './Components/CardIconHeader'
import ContactRoleIcon from '../../../assets/icons/ContactRoleIcon'
import { useTheme } from '../../../middleware/ThemeContext'
import UserInfo from './Components/UserInfo'
import OpitonsIcon from '../../../assets/icons/OptionsIcon'
import { Button } from '../../../components/form/Button'
import ArrowIcon from '../../../assets/icons/ArrowIcon'

const UserData = [
    {
        signedUrl: null,
        name: 'Benjamin Albert Strokes',
        subTitle: '2 hours ago'
    },
    {
        signedUrl: null,
        name: 'Benjamin Albert Strokes 2',
        subTitle: '15 hours ago'
    },
    {
        signedUrl: null,
        name: 'Benjamin Albert Strokes 3',
        subTitle: 'Yesterday'
    },
    {
        signedUrl: null,
        name: 'Benjamin Albert Strokes 4',
        subTitle: 'Yesterday'
    }
];

const NewMembersSignUp = () => {
    const {theme} = useTheme();
  return (
    <DashboardCard theme={theme}>
        <CardIconHeader
            icon={<ContactRoleIcon size={24} Color={theme.CorporateTheme.colors.blueberry} /> }
            title='New Member Signup'
            count="524"
            iconBgColor='rgba(5, 86, 203, 0.1)'
            tooltipText='This list is based on a prebuilt query showing members who joined recently and are now due for their first renewal.'
            viewIcon={true}
        />
        <hr style={{ marginTop: '20px' }} />
        <div className='my-4'>
            {UserData.map((data, index) => (
                <div className='d-flex align-items-center justify-content-between mb-4' key={index}>
                    <UserInfo
                        image={data.signedUrl ? data.signedUrl : ''}
                        name={data.name}
                        subTitle={data.subTitle}
                    />
                    <OpitonsIcon rotation={90} color={theme.CorporateTheme.colors.graniteGrey} />
                </div>
            ))}
        </div>

        <Button
            theme={theme}
            $variant='customButton'
            textColor={theme.CorporateTheme.colors.primary}
            color={theme.CorporateTheme.colors.primary}
            fontSize='12px'
            fontWeight='600'
            borderColor={theme.CorporateTheme.colors.filterBG}
            width='100%'
            textPosition='start'
        >
            View All New Member Signup
            <ArrowIcon rotate='right' color={theme.CorporateTheme.colors.gunmetal} />
        </Button>
    </DashboardCard>
  )
}

export default NewMembersSignUp